// extracted by mini-css-extract-plugin
export var dateLabel = "_3z-0";
export var dateLabelError = "_3z-1";
export var fullWidth = "_3z-2";
export var smaller = "_3z-3";